export const getCommentsRedirectLink = (page) => {
  const urlWithoutHash = `${window.location.origin}${window.location.pathname}${window.location.search}`;

  return `${window.location.origin}/${page}?redirectUrl=${urlWithoutHash}`;
}



// WEBPACK FOOTER //
// ./webapp/utils/url.js